// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type OperatingManualContentType = {
  title: string;
  children: React.ReactNode;
};

const OperatingManualContent = ({
  title,
  children,
}: OperatingManualContentType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <Box
      sx={{
        px: { xs: "0px", md: "20px" },
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography fontSize="16px" fontWeight={600}>
        {t(title)}
      </Typography>

      {children}
    </Box>
  );
};

export default OperatingManualContent;
